import React from "react"
import Image from "./image"

const NegativeImage = ({ filename, alt }) => <Image filename={filename} alt={alt} className="image-filter negative-filter"/>

export default NegativeImage
